export const PRICING_PATH = "/pricing";

export const ANALYTICS_PRODUCT_PATH = "/products/analytics";

export const INTELLIGENCE_PRODUCT_PATH = "/products/intelligence";

export const REWARDS_PRODUCT_PATH = "/products/rewards";

export const CAMPAIGNS_PRODUCT_PATH = "/products/campaigns";

export const WORKSPACE_PRODUCT_PATH = "/products/workspace";

export const TERMS_PATH = "/legal/terms";

export const PRIVACY_PATH = "/legal/privacy";

export const GUIDE_PATH = "/guide";

export const DEMO_PATH = "/demo";

export const SUPPORT_HREF = "/support";

export const CONTACT_EMAIL = "contact@dislace.com";

export const LLMS_FULL_PATH = "/llms-full.txt";

export { tenantHomePath as tenantHome } from "@colossus/contracts/tenant-home";
